import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoader:false,
  alldesignation:[],
}

export const designationSlice = createSlice({
  name: 'designation',
  initialState,
  reducers: {
    getAllDesignationStart: (state,action) => {
        state.isLoader= true
    },
    getAllDesignationSuccess: (state,action) => {
        state.isLoader= false
        state.alldesignation = action.payload
    },
    updateDesignation: (state,action) => {
        const Index = state.alldesignation.findIndex(designation => designation.CODE === Number(action.payload.CODE));
        if(Index !== -1 ){
          state.alldesignation[Index] = action.payload;
        }
      }
    
  },
})

export const {getAllDesignationStart, getAllDesignationSuccess, updateDesignation  } = designationSlice.actions

export default designationSlice.reducer